import React from "react";
import { CommentReference, UserToken } from "../../amorg-common";
import { ProtectedPageContext } from "../../pages/_contexts/ProtectedPageContext";
import { Drawer } from "../Drawer";
import { CommentPanel } from "./CommentPanel";

export function CommentDrawer(props:{ 
    visible: boolean, 
    reference:CommentReference,
    onClose: () => void, 
    onCommentsLoaded?:(commentCount:number)=>void })
{
    const ctx = React.useContext(ProtectedPageContext);

    return (
        <Drawer visible={props.visible} onClose={props.onClose}>
            <CommentPanel 
                activeUser={ctx.user as UserToken}
                commentReference={props.reference}
                onGetCommentCount={(count) => props.onCommentsLoaded?.(count)} 
            />
        </Drawer>
    );
}